<div class="p-5 flex flex-col gap-4 border-b-2 border-dashed">
    <div class="flex gap-2 w-full items-center justify-between h-10">
        <ng-container *ngIf="canApprove">
        <div class="italic font-thin">
            {{'ATTACHMENTS_LEGEND' | translate}}
        </div>
        <button mat-flat-button (click)="openFileModal()">
            <div class="flex flex-row gap-2 items-center justify-center">
                <strong>{{ 'UPLOAD' | translate }}</strong>
                <mat-icon>upload</mat-icon>
            </div>
        </button>
        </ng-container>
    </div>
    <div class="flex gap-2">
        <mat-accordion class="w-full">
            <mat-expansion-panel class="!shadow-none !border-0 !rounded-none">
                <mat-expansion-panel-header class="!bg-white !border-b !border-gray-200 !p-0">
                    <div class="flex justify-between w-full mr-4">
                    <div> {{ "ATTACHMENTS_LIST" | translate}}</div>
                    <div>
                    <span class="text-gray-500 text-sm">{{ attachments.length }} {{ "ATTACHMENTS" | translate }}</span>
                    </div>
                </div>
                </mat-expansion-panel-header>
                <ul class="p-4 space-y-2">
                    <li *ngFor="let file of attachments" class="flex items-center text-sm text-gray-700">
                        <mat-icon class="mr-2 text-gray-500">insert_drive_file</mat-icon>
                        <span class="font-medium">{{ file.filename }}</span>
                        <span class="ml-auto text-gray-400 text-xs">{{ formatSize(file.size) }}</span>
                    </li>
                </ul>
                <p *ngIf="attachments.length === 0" class="p-4 text-gray-400">{{ "ATTACHMENTS_LIST_EMPTY" | translate }}</p>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>